// Static placeholder for the article's interactive Three.js scenes.
//
// The interactive CSG demos are built iteratively (one scene at a time). Two uses:
//  • `variant="coming-soon"` (default) — a scene whose interactive demo isn't
//    built yet; its mount point just shows the caption + a "Coming soon" note.
//  • `variant="loading"` — the pre-mount / Suspense-fallback state of a scene
//    that IS built (shown by LazyScene before its code-split chunk loads).
//
// Either way this is pure HTML — no Three.js, no WebGL — so it is exactly what
// the build-time Puppeteer prerender snapshots into the static HTML, and it
// never blocks `[data-prerender-ready]`.

interface ScenePlaceholderProps {
  // Human-readable caption describing what the demo shows.
  caption: string
  // Aspect ratio of the demo stage (CSS aspect-ratio value).
  aspect?: string
  variant?: 'coming-soon' | 'loading'
}

const ScenePlaceholder = ({caption, aspect = '16 / 10', variant = 'coming-soon'}: ScenePlaceholderProps) => (
  <figure className="seo-scene" aria-label={caption}>
    <div className="seo-scene-stage" style={{aspectRatio: aspect}}>
      <span className="seo-scene-badge">
        <span className="seo-scene-badge-dot" />
        Interactive demo
      </span>
      <span className="seo-scene-note">{variant === 'loading' ? 'Loading interactive demo…' : 'Coming soon'}</span>
    </div>
    <figcaption className="seo-scene-cap">{caption}</figcaption>
  </figure>
)

export default ScenePlaceholder
